module.exports = ".plot:hover{\n    background: rgb(218, 218, 218);\n}\n.plot plotly-plot{\n    width: 100% !important;\n    height: 100% !important;\n}"